import { IconProps, iconA11yProps } from '../types';

export const Check = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={classNames} {...iconA11yProps(label)}>
        <path d="M2 11L9 18L22 5" />
    </svg>
);
